import { MatTableDataSource } from '@angular/material/table';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Levels } from 'src/shared/logger/levels.enum';
import { HomeService } from 'src/homepage/shared/home.service';
import { monitorProvisionObj } from 'src/homepage/shared/home.models';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { AccessAuthService } from 'src/shared/access.auth.service';


@Component({
  templateUrl: './dialog-monitor-provision.component.html',
  styleUrls: ['./dialog-monitor-provision.component.css'],
  providers: [HomeService]
})
export class DialogMonitorProvisionComponent implements OnInit {
  unitsToBeHandled: monitorProvisionObj[] = [];
  displayedColumns = ["provisionIcon", "description", "action"];
  logsTableData: MatTableDataSource<monitorProvisionObj> = new MatTableDataSource([]);

  pageTitle: string = "";
  message: string = "";
  globalProcessingFlag: boolean = false;
  adminAuthorization: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogMonitorProvisionComponent>,
    private homeService: HomeService,
    private loggerService: LoggerService,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
    public accessAuthService: AccessAuthService,
    @Inject(MAT_DIALOG_DATA) public monitorOrProvision: string
  ) { }

  ngOnInit(): void {
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)

    if (this.monitorOrProvision == "Provision") {
      this.pageTitle = "UnProvisioned";
      this.homeService.getUnprovisionedUnits().subscribe(data => {
        for (const key in data.data) {
          for (let i = 0; i < data.data[key].length; i++) {
            this.unitsToBeHandled.push(new monitorProvisionObj(data.data[key][i]["system_ip"], data.data[key][i]["system_name"], key))
          }
        }
        this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
        this.message = "Total units retrieved are " + this.unitsToBeHandled.length + " units";
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else if (this.monitorOrProvision == "Monitor") {
      this.pageTitle = "UnMonitored";
      this.homeService.getUnmonitoredUnits().subscribe(data => {
        for (const key in data.data) {
          for (let i = 0; i < data.data[key].length; i++) {
            this.unitsToBeHandled.push(new monitorProvisionObj(data.data[key][i]["system_ip"], data.data[key][i]["system_name"], key))
          }
        }
        this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
        this.message = "Total units retrieved are " + this.unitsToBeHandled.length + " units";

      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })

    } else if (this.monitorOrProvision == "UnProvision") {
      this.pageTitle = "Provisioned";
      this.homeService.getProvisionedUnits().subscribe(data => {
        for (const key in data.data) {
          for (let i = 0; i < data.data[key].length; i++) {
            this.unitsToBeHandled.push(new monitorProvisionObj(data.data[key][i]["system_ip"], data.data[key][i]["system_name"], key))
          }
        }
        this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
        this.message = "Total units retrieved are " + this.unitsToBeHandled.length + " units";
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else if (this.monitorOrProvision == "UnMonitor") {
      this.pageTitle = "Monitored";
      this.homeService.getMonitoredUnits().subscribe(data => {
        for (const key in data.data) {
          for (let i = 0; i < data.data[key].length; i++) {
            this.unitsToBeHandled.push(new monitorProvisionObj(data.data[key][i]["system_ip"], data.data[key][i]["system_name"], key))
          }
        }
        this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
        this.message = "Total units retrieved are " + this.unitsToBeHandled.length + " units";

      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })

    } else {
      this.unitsToBeHandled = [];
      this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
    }
  }

  onSubmitData() {

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  openDialog(): void {
    let dialogData = { title: this.monitorOrProvision + " All Units", message: "You are going to send a request to " + this.monitorOrProvision + " all units" }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: dialogData.title, message: dialogData.message },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sendBulkAppropriateRequest()
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.logsTableData.filter = filterValue.trim().toLowerCase();
  }

  sendAppropriateRequest(element: monitorProvisionObj) {
    element.processingFlag = true;
    if (this.monitorOrProvision == "Provision") {
      this.homeService.provisionUnit(element.system_ip).subscribe(data => {
        element.processingFlag = false;
        element.resultSuccessFlag = true;
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        element.processingFlag = false;
        element.resultFailedFlag = true;
      })
    } else if (this.monitorOrProvision == "Monitor") {
      this.homeService.monitorUnit(element.system_ip, 1).subscribe(data => {
        element.processingFlag = false;
        element.resultSuccessFlag = true;
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        element.processingFlag = false;
        element.resultFailedFlag = true;
      })
    } else if (this.monitorOrProvision == "UnProvision") {
      this.homeService.unProvisionUnit(element.system_ip).subscribe(data => {
        element.processingFlag = false;
        element.resultSuccessFlag = true;
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        element.processingFlag = false;
        element.resultFailedFlag = true;
      })
    } else if (this.monitorOrProvision == "UnMonitor") {
      this.homeService.unMonitorUnit(element.system_ip, 0).subscribe(data => {
        element.processingFlag = false;
        element.resultSuccessFlag = true;
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        element.processingFlag = false;
        element.resultFailedFlag = true;
      })
    }

  }

  sendBulkAppropriateRequest() {
    this.globalProcessingFlag = true;
    let unitsBeSent: any = this.adjustHandledUnits();

    if (this.monitorOrProvision == "Provision") {
      this.homeService.bulkProvision(unitsBeSent).subscribe(data => {
        this.openSnackBar(data["message"], "Processing");
      }, err => {
        this.globalProcessingFlag = false;
        this.openSnackBar(err["message"], "Erocessing");
      })
    } else if (this.monitorOrProvision == "UnProvision") {
      this.homeService.bulkUnProvision(unitsBeSent).subscribe(data => {
        this.openSnackBar(data["message"], "Processing");
      }, err => {
        this.globalProcessingFlag = false;
        this.openSnackBar(err.error?.message ? err.error?.message : "Error", "Error");
      })
    } else if (this.monitorOrProvision == "Monitor") {
      this.adjustProcessingFlagForAllUnits();
      this.homeService.bulkMonitor(unitsBeSent).subscribe(data => {
        this.globalProcessingFlag = false;
        this.unitsToBeHandled.forEach(item => {
          item.processingFlag = false;
          item.resultSuccessFlag = true
        })
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        this.globalProcessingFlag = false;
        this.unitsToBeHandled.forEach(item => {
          item.processingFlag = false;
          item.resultFailedFlag = true
        })
      })
    } else if (this.monitorOrProvision == "UnMonitor") {
      this.adjustProcessingFlagForAllUnits();
      this.homeService.bulkUnMonitor(unitsBeSent).subscribe(data => {
        this.globalProcessingFlag = false;
        this.unitsToBeHandled.forEach(item => {
          item.processingFlag = false;
          item.resultSuccessFlag = true
        })
      }, err => {
        this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        this.globalProcessingFlag = false;
        this.unitsToBeHandled.forEach(item => {
          item.processingFlag = false;
          item.resultFailedFlag = true
        })
      })
    } else {
      this.unitsToBeHandled.forEach(item => {
        item.processingFlag = false;
      })
      this.globalProcessingFlag = false;
    }

  }

  adjustProcessingFlagForAllUnits() {
    //let toBeSentUnits: any[] = []
    this.unitsToBeHandled.forEach(item => {
      item.processingFlag = true
      //toBeSentUnits.push({ "system_ip": item.system_ip })
    })
    //return toBeSentUnits;
  }

  adjustHandledUnits() {
    let unitsToBeSent: any;
    if (this.monitorOrProvision == "Monitor" || this.monitorOrProvision == "UnMonitor") {
      unitsToBeSent = "";
      this.unitsToBeHandled.forEach(item => {
        unitsToBeSent = unitsToBeSent + "'" + item.system_ip + "'" + ","
      })
      if (unitsToBeSent.endsWith(",")) {
        unitsToBeSent = unitsToBeSent.slice(0, unitsToBeSent.length - 1)
      }
    }
    if (this.monitorOrProvision == "Provision" || this.monitorOrProvision == "UnProvision") {
      unitsToBeSent = [];
      this.unitsToBeHandled.forEach(item => {
        unitsToBeSent.push({ "system_ip": item.system_ip })
      })
    }
    return unitsToBeSent;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

}
